import isNil from "lodash/fp/isNil";

class Controller {
  constructor(Events, $stateParams, Sections, Lists, CityHandler, City) {
    "ngInject";

    this.Events = Events;
    this.Lists = Lists;
    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.activeParams = $stateParams;

    this.addItemEvent = Events.getAddEvent("backups");
    this.filterEvent = Events.getFilterEvent("backups");
    this.sortEvent = Events.getSortEvent("backups");
    this.paginateEvent = Events.getPaginateEvent("backups");
    this.sections = Sections.routesSections;

    // Get ride category per city
    this.City = City;
    this.dashboardCity = CityHandler.get();
    this.getRideCategoriesEvent = this.Events.getUpdateEvent(
      "getRideCategories"
    );
  }

  $onInit() {
    this.getRideCategory(this.dashboardCity);
  }

  getRideCategory(city) {
    const param = {};
    if (!isNil(city)) {
      param.city = city._id;
    }
    this.Lists.all.rideCategoryList = [];
    this.City.getRideCategory(param).$promise.then((response) => {
      if (response.hits) {
        this.Lists.all.rideCategoryList = response.hits.map(
          ({ _id: name, _source: category }) => ({
            name,
            title: `${category.ride_type} ${category.service_type}`,
            param: "category",
          })
        );
      }
      this.Events.emit(this.getRideCategoriesEvent);
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/backups/backups.controller.js